import React from 'react'
import { Icon,Button } from 'semantic-ui-react'

export const CheckCircle = () => (
    <Button basic color="blue" style={{display:'contents'}}>
    <Icon name="check circle" />   
     </Button>

)
